import { applyMiddleware, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension/logOnlyInProduction";

import rootReducer from "./reducers";
import thunk from "redux-thunk";
const composeEnhancers = composeWithDevTools({});
export default createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));
